import { Component } from "react"
import { Link, Navigate } from "react-router-dom"
import Top from "./Top"
import Bottom from "./Bottom"
import Qrs1 from "./img/qrs1.png"
import Qrs2 from "./img/qrs2.jpg"
import Qrs3 from "./img/qrs3.jpg"
import Qrs4 from "./img/qrs4.jpg"
import SmartFruitRobot from './img/智能果蔬采摘机器人.jpg';
import SmartMolecularDiagnosis from './img/智能高效分子光学诊断系统.jpg';
import SmartMolecularAnalysis from './img/智能生物分子分析系统.jpg';
import SmartPatrolRobot from './img/智能工业巡检机器人.jpg';
import SmartTrashCan from './img/移动智能垃圾桶.jpg';
import DualArmSystem from './img/双手臂互联协同系统.jpg';
import Xspy1 from "./img/xspy1.png"
import Hjzs1 from "./img/hjzs1.jpg"
import Hjzs2 from "./img/hjzs2.jpg"
import Hjzs3 from "./img/hjzs3.jpg"
import Hjzs4 from "./img/hjzs4.jpg"
import Hjzs5 from "./img/hjzs1.jpg"
import Xkjs1 from "./img/xkjs1.jpg"
import Xkjs2 from "./img/xkjs2.jpg"
import Xkjs3 from "./img/xkjs3.jpg"
import Xkjs4 from "./img/xkjs4.jpg"
import Xkjs5 from "./img/xkjs5.jpg"
import Xkjs6 from "./img/xkjs6.jpg"
import Xkjs7 from "./img/xkjs7.jpg"
import Xkjs8 from "./img/xkjs8.jpg"
import Xkjs9 from "./img/xkjs9.jpg"
import Xsjz1 from "./img/xsjz1.jpg"
import Xsjz2 from "./img/xsjz2.jpg"
import Xsjz3 from "./img/xsjz3.jpg"
import Xsjz4 from "./img/xsjz4.jpg"
import InnovationCompetition1 from "./img/cxcy1.png";
import InnovationCompetition2 from "./img/cxcy2.jpg";
import InnovationCompetition3 from "./img/cxcy3.jpg";
import InnovationCompetition4 from "./img/cxcy4.jpg";
import Qyjx1 from "./img/qyjx1.jpg"
import Qyjx2 from "./img/qyjx2.jpg"
import Qyjx3 from "./img/qyjx3.png"
import Qyjx4 from "./img/qyjx4.png"
import Cxcy1 from "./img/cxcy1.png"
import Cxcy2 from "./img/cxcy2.jpg"
import Cxcy3 from "./img/cxcy3.jpg"
import Cxcy4 from "./img/cxcy4.jpg"
import Zzkt1 from "./img/zzkt1.jpg"
import Zzkt2 from "./img/zzkt2.jpg"
import Zzkt3 from "./img/zzkt3.jpg"
import Shgl1 from "./img/shgl1.jpg"
import Shgl2 from "./img/shgl2.jpg"
import Shgl3 from "./img/shgl3.jpg"
import Shgl4 from "./img/shgl4.jpg"
import Shgl5 from "./img/shgl5.jpg"
import Dgly1 from "./img/dgly1.jpg"
import Dgly2 from "./img/dgly2.jpg"
import Dgly3 from "./img/dgly3.jpg"
import Shdd1 from "./img/shdd1.jpg"
import Shdd2 from "./img/shdd2.jpg"
import Shss1 from "./img/shss1.jpg"
import Shss2 from "./img/shss2.jpg"
import Zjyb1 from "./img/zjyb1.JPG"
import Zjyb2 from "./img/zjyb2.jpg"
import Zjyb3 from "./img/zjyb3.jpg"
import Rssx1 from "./img/rssx1.jpg"
import Rssx2 from "./img/rssx2.jpg"
import "./index.css"
import "./PageLayout.css"
import "./ProjectDetail.css"

// 案例与教学素材项目数据
const projectData = [
  {
    id: 1,
    title: "智能避障小车",
    image: Qrs1,
    description: "通过安装在小车四周的超声波传感器反馈车辆与障碍物的距离，小车根据各种传感器数值判断车辆所遇到的环境，控制车辆前进后退避开障碍物。该项目培养了学生在嵌入式系统设计、传感器应用和自动控制方面的综合能力。"
  },
  {
    id: 2,
    title: "交互式智能机器人",
    image: Qrs2,
    description: "交互式机器人部件包括电池、电机、编码器、IMU、控制板、卡片电脑、RGBD 相机、激光雷达和转向舵机。可以用于ROS 多机通讯，OpenCV机器视觉，路径规划等实验和开发。该项目提升了学生在机器人操作系统和人工智能算法方面的实践技能。"
  },
  {
    id: 3,
    title: "智慧抓取系统",
    image: Qrs3,
    description: "系统以树莓派4B为主控，OpenCV为图像处理库，采用ROS机器人操作系统，内置MoveIt运动学，可实现物体识别、抓取、颜色追踪、码垛等多种功能。该项目锻炼了学生在计算机视觉和机械控制领域的综合应用能力。"
  },
  {
    id: 4,
    title: "智慧门禁系统",
    image: Qrs4,
    description: "集成人脸识别、红外体温识别、高温警告、门禁控制、健康码核验、数据实时上传等功能的门禁系统。能简化进出操作，能有效减少人员接触、节约排队时间，对助力后疫情时代的健康防控有一定的工程应用价值。该项目体现了学生在物联网和疫情防控技术方面的创新能力。"
  },
  {
    id: 5,
    title: "智能果蔬采摘机器人",
    image: SmartFruitRobot,
    description: "智能果蔬采摘机器人项目培养学生在机器人控制、图像识别和自动控制方面的综合能力。通过该系统，学生可以学习机械臂控制、路径规划、视觉识别等关键技术。"
  },
  {
    id: 6,
    title: "智能高效分子光学诊断系统",
    image: SmartMolecularDiagnosis,
    description: "该系统结合了光学技术和分子诊断技术，培养学生在精密光学仪器设计和生物医学工程方面的实践能力。学生通过该项目掌握光路设计、信号处理和系统集成等技能。"
  },
  {
    id: 7,
    title: "智能生物分子分析系统",
    image: SmartMolecularAnalysis,
    description: "智能生物分子分析系统项目涉及生物传感器、信号处理和数据分析技术。通过该项目，学生可以学习嵌入式系统在生物医学领域的应用，提升系统设计和工程实践能力。"
  },
  {
    id: 8,
    title: "智能工业巡检机器人",
    image: SmartPatrolRobot,
    description: "智能工业巡检机器人项目涵盖了移动机器人导航、传感器融合和远程监控技术。学生通过该系统学习嵌入式系统在工业自动化中的应用，培养系统集成和故障诊断能力。"
  },
  {
    id: 9,
    title: "移动智能垃圾桶",
    image: SmartTrashCan,
    description: "移动智能垃圾桶项目结合了物联网、传感器技术和自动控制技术。学生通过该项目学习智能设备的设计与开发，掌握环境感知、自主导航和人机交互等关键技术。"
  },
  {
    id: 10,
    title: "双手臂互联协同系统",
    image: DualArmSystem,
    description: "双手臂互联协同系统项目专注于多机器人协同控制技术。学生通过该系统学习多轴运动控制、协同算法和实时通信技术，提升在复杂控制系统设计方面的能力。"
  }
]

// 学生培养项目数据
const studentData = [
  {
    id: 1,
    title: "创新创业",
    image: Cxcy3,
    description: "学生参与各类创新创业项目，培养实践能力和创新思维，通过实际项目锻炼解决复杂工程问题的能力。项目涵盖智能硬件开发、嵌入式系统设计、物联网应用等多个技术领域，全面提升学生的工程实践能力。学生在创新创业方面取得了显著成果，包括：",
    additionalImages: [Cxcy1, Cxcy2, Cxcy3, Cxcy4]
  },
  {
    id: 2,
    title: "学科竞赛",
    image: Xkjs2,
    description: "学生积极参与各类学科竞赛，在光电设计大赛、全国大学生电子设计竞赛、挑战杯等高水平竞赛中屡获佳绩。通过竞赛实践，学生将理论知识与实际应用相结合，提升了创新能力和解决复杂工程问题的水平。竞赛经历不仅锻炼了学生的专业技能，也培养了团队协作精神和项目管理能力，为未来的职业发展奠定了坚实基础。学生在各类学科竞赛中取得了丰硕成果，包括：",
    additionalImages: [Xkjs1, Xkjs2, Xkjs3, Xkjs4, Xkjs5, Xkjs6, Xkjs7, Xkjs8, Xkjs9, Hjzs1, Hjzs2, Hjzs3, Hjzs4]
  },
  {
    id: 3,
    title: "学术讲座",
    image: Hjzs2,
    description: "学生积极参与各类学术讲座和学术交流活动，拓宽专业视野，了解前沿技术动态。通过与行业专家和学者的交流，学生能够把握技术发展趋势，提升学术素养和创新能力。其中包括“智见光影：AI驱动下的照明设计产业新模态”研讨会（图片1-2）以及复旦大学田鹏飞教授基于第三代半导体micro-LED的显示通信传感系统应用讲座（图片3-4）：",
    additionalImages: [Xsjz1, Xsjz2, Xsjz3, Xsjz4]
  },
  {
    id: 4,
    title: "自主课堂",
    description: "学生参与自主课堂活动，通过自主学习和团队合作，提升自主学习能力和团队协作精神。在自主课堂中，学生能够充分发挥主观能动性，培养独立思考和解决问题的能力。",
    additionalImages: [Zzkt1, Zzkt2, Zzkt3]
  }
]

// 企业践习项目数据
const enterpriseData = [
  {
    id: 1,
    title: "上海光联照明有限公司参观",
    image: Shgl5,
    description: "学生参观上海光联照明有限公司，了解现代照明技术的发展和应用。通过实地参观，学生了解了LED照明产品的设计、生产和测试流程，对光电技术的实际应用有了更深入的认识。",
    additionalImages: [Shgl1, Shgl2, Shgl3, Shgl4, Shgl5]
  },
  {
    id: 2,
    title: "德国莱茵集团参观",
    image: Dgly1,
    description: "学生参观德国莱茵集团，了解国际领先的检测认证技术和质量管理体系。通过与企业技术人员的交流，学生对产品质量控制和国际标准有了更深刻的理解。",
    additionalImages: [Dgly1, Dgly2, Dgly3]
  },
  {
    id: 3,
    title: "上海电动工具研究所（集团）有限公司参观",
    image: Shdd1,
    description: "学生参观上海电动工具研究所（集团）有限公司，了解电动工具的研发、设计和制造流程。通过实地参观，学生了解了电动工具产品的设计原理、生产工艺和质量检测标准，对机电一体化技术的实际应用有了更深入的认识。",
    additionalImages: [Shdd1, Shdd2]
  },
  {
    id: 4,
    title: "上海三思电子工程有限公司参观",
    image: Shss1,
    description: "学生参观上海三思电子工程有限公司，了解LED显示系统和智能交通产品的研发与生产流程。通过实地参观，学生了解了LED显示屏的设计原理、生产工艺和质量控制标准，对光电技术在智慧城市领域的应用有了更深入的认识。",
    additionalImages: [Shss1, Shss2]
  },
  {
    id: 5,
    title: "浙江友邦集成吊顶股份有限公司参观",
    image: Zjyb1,
    description: "学生参观浙江友邦集成吊顶股份有限公司，了解集成吊顶产品的设计、研发和生产流程。通过实地参观，学生了解了现代建筑装饰材料的生产工艺、质量控制体系和产品创新理念，对建筑装饰行业的发展趋势有了更深入的认识。",
    additionalImages: [Zjyb1, Zjyb2, Zjyb3]
  },
  {
    id: 6,
    title: "认识实习",
    image: Rssx1,
    description: "学生前往江苏芯梦半导体设备有限公司和华世德电子科技有限公司进行认识实习，深入了解半导体设备制造和电子科技行业的生产流程和技术应用。通过实地参观和学习，学生对相关行业的技术发展和产业现状有了更全面的认识，为后续的专业学习和职业规划奠定了基础。",
    additionalImages: [Rssx1, Rssx2]
  }
]

class ProjectDetail extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  }

  render() {
    // 获取项目ID和类型
    const { id } = this.props;
    const projectId = parseInt(id);
    
    // 根据路由路径判断项目类型
    const path = window.location.pathname;
    let project;
    
    if (path.startsWith('/project/')) {
      project = projectData.find(p => p.id === projectId)
    } else if (path.startsWith('/student/')) {
      project = studentData.find(p => p.id === projectId)
    } else if (path.startsWith('/enterprise-project/')) {
      project = enterpriseData.find(p => p.id === projectId)
    }
    
    // 如果找不到项目，重定向到对应页面
    if (!project) {
      if (path.startsWith('/student/')) {
        return <Navigate to="/students" />
      } else if (path.startsWith('/enterprise-project/')) {
        return <Navigate to="/enterprise" />
      } else {
        return <Navigate to="/projects" />
      }
    }

    // 确定返回链接
    let backLink = "/projects";
    let backText = "返回案例与教学素材";
    
    if (path.startsWith('/student/')) {
      backLink = "/students";
      backText = "返回学生培养";
    } else if (path.startsWith('/enterprise-project/')) {
      backLink = "/enterprise";
      backText = "返回企业践习";
    }

    return (
      <div>
        <Top />
        <div className="page-container">
          <div className="page-header">
            <h1 className="page-title">{project.title}</h1>
          </div>
          <div className="project-detail-container">
            {(path.startsWith('/student/') ? (project.id !== 1 && project.id !== 2 && project.id !== 3) && project.id !== 4 : true) && (
              <div className="project-detail-image">
                <img src={project.image} alt={project.title} />
              </div>
            )}
            <div className="project-detail-content">
              <p>{project.description}</p>
              {/* 如果是自主课堂项目，将第一张图片放在中间 */}
              {path.startsWith('/student/') && project.id === 4 && project.additionalImages && project.additionalImages.length > 0 && (
                <div className="project-detail-image">
                  <img src={project.additionalImages[0]} alt="自主课堂活动图片" />
                </div>
              )}
              {/* 如果是学生培养项目且有额外图片，显示额外的图片 */}
              {project.id >= 1 && project.id <= 4 && path.startsWith('/student/') && project.additionalImages && (
                <div className="additional-images-container">
                  <h3>{project.id === 1 ? '学生创新创业获奖成果' : project.id === 2 ? '学生学科竞赛获奖成果' : project.id === 3 ? '学术讲座活动掠影' : '自主课堂活动掠影'}</h3>
                  <div className="additional-images-grid">
                    {project.additionalImages.map((img, index) => {
                      // 对于自主课堂项目（ID=4），跳过第一张图片，因为它已经在上面单独显示
                      if (project.id === 4 && index === 0) {
                        return null; // 跳过第一张图片
                      }
                      
                      // 为不同项目类型设置不同的alt文本
                      let altText;
                      if (project.id === 1) {
                        altText = `创新创业活动${index + 1}`;
                      } else if (project.id === 2) {
                        altText = `学科竞赛活动${index + 1}`;
                      } else if (project.id === 3) {
                        altText = `学术讲座活动${index + 1}`;
                      } else if (project.id === 4) {
                        // 对于自主课堂项目，由于第一张图片已经单独显示，所以剩余图片的索引需要调整
                        altText = `自主课堂活动${index + 1}`;
                      }
                      
                      return (
                        <div key={index} className="additional-image-item">
                          <img src={img} alt={altText} />
                        </div>
                      );
                    }).filter(Boolean)}
                  </div>
                </div>
              )}
              
              {/* 如果是企业践习项目且有额外图片，显示额外的图片 */}
              {path.startsWith('/enterprise-project/') && project.additionalImages && (
                <div className="additional-images-container">
                  <h3>企业践习活动掠影</h3>
                  <div className="additional-images-grid">
                    {project.additionalImages.map((img, index) => {
                      // 跳过与主图片相同的图片
                      if (img === project.image) {
                        return null; // 跳过这张图片
                      }
                      
                      return (
                        <div key={index} className="additional-image-item">
                          <img src={img} alt={`企业践习活动${index + 1}`} />
                        </div>
                      );
                    }).filter(Boolean)}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <Bottom />
      </div>
    )
  }
}

export default ProjectDetail